import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=39475c4c&scoped=true&"
import script from "./EditEvent.vue?vue&type=script&lang=js&"
export * from "./EditEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39475c4c",
  null
  
)

export default component.exports